import "./style.css";
import WebProgress from "./WebProgress.js";
export default WebProgress;
